// app
export const GetBaseUrl = (suffix = '') => {
  return document.URL.substr(0, document.URL.lastIndexOf('/')) + '/' + suffix;
};

export const GetAssetsBase = () => {
  return 'assets/';
};

export const GetLocationAssetsBase = () => {
  return GetAssetsBase() + 'locations/';
};

export const GetLocationSelfieUrl = (locationid) => {
  return 'assets/locations/' + locationid.toLowerCase() + '/selfie.png';
};
export const GetLocationVideoUrl = (locationid) => {
  return 'assets/locations/' + locationid.toLowerCase() + '/video.mp4';
};
export const GetLocationSouvenirUrl = (locationid) => {
  return 'assets/locations/' + locationid.toLowerCase() + '/souvenir.png';
};

// api
export const API_BASE = 'https://turner-apps.com/api/';
export const API_POLL_DATA = API_BASE + 'get_app_details/en_GB/apps/world-of-mystery';
export const API_POLL_SUBMIT = API_BASE + 'enter_multiple/en_GB/apps/world-of-mystery';
export const API_POLL_RESULTS = API_BASE + 'get_all_entry_summaries/en_GB/apps/world-of-mystery';

export const GetApiData = (apiURL, onComplete) => {
  // Create a request variable and assign a new XMLHttpRequest object to it.
  var request = new XMLHttpRequest();

  // Open a new connection, using the GET request on the URL endpoint
  request.open('GET', apiURL, true);
  // set request load callback
  request.onload = (e) => {
    onComplete(e.target.response);
  };
  //send request
  request.send();
};

export const SubmitApiData = (submitData, apiURL, onComplete) => {
  var request = new XMLHttpRequest();
  // POST to httpbin which returns the POST data as JSON
  request.open('POST', apiURL, true);

  request.onload = (e) => {
    onComplete(e.target.response);
  };

  var formData = new FormData();
  Object.keys(submitData).forEach((key) => {
    formData.append(key, JSON.stringify(submitData[key]));
  });

  request.send(formData);
};



// WEBPACK FOOTER //
// ./js/app/constants/AppUrls.js